import { useMemo } from 'react';
import { DateRange } from 'react-aria-components';

import { useGetAgentFromPath, useTimezone } from '@/hooks';
import { toAgentStatisticId, useGetAgentStatistics } from '@/hooks/api';
import { dateRangeToDates, toNumber } from '@/utils';

import { createDateRange, DEFAULT_NUM_DAYS } from './utils';

export type UseStatisticsOpts = {
  dateRange?: DateRange | null;
  dateSelection?: number | string;
};

export const useStatistics = ({ dateRange, dateSelection }: UseStatisticsOpts = {}) => {
  const { data: agent } = useGetAgentFromPath();
  const timezone = useTimezone();

  const statisticsOptions = useMemo(() => {
    if (!agent || !dateRange) return;
    const { end: before, start: after } = dateRangeToDates(dateRange, timezone);
    return toAgentStatisticId(agent?.agentId, before, after);
  }, [agent, dateRange, timezone]);

  const previousStatisticsOptions = useMemo(() => {
    if (!agent || !dateRange) return;
    const previousDateRange = createDateRange(
      toNumber(dateSelection, DEFAULT_NUM_DAYS),
      dateRange.start.toDate(timezone)
    );
    const { end: before, start: after } = dateRangeToDates(previousDateRange, timezone);
    return toAgentStatisticId(agent?.agentId, before, after);
  }, [agent, dateRange, dateSelection, timezone]);

  const { data: statistics } = useGetAgentStatistics(statisticsOptions);
  const { data: previousStatistics } = useGetAgentStatistics(previousStatisticsOptions);

  return { statistics, previousStatistics };
};
